import { Http, Response, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { GETObservationListVM, GETObservationsCusVM, PIPDetailsVM, PIPImplementAttachmentsVM, PIPImplementAuditTrailVM, PIPImplementImagesVM, PIPImplementsVM, PIPImplemetLevelforAsset, PIPImplmentsLevelVM, PIPStatusVM, PIPSupportDocVM, PIPSupportProgramLevelsVM, userAlertsVM } from '../entities/global/model';


@Injectable()
export class ProgramImprovementService {

  constructor(private _http: Http) { }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  public getPIPStatus(): Observable<PIPStatusVM[]> {
    return this._http.get('api/ProductImprovement/getPIPStatus').share().map(
      (response: Response) => <PIPStatusVM[]>response.json()).catch(this.handleError);
  }

  public getPIPSupportLevel(): Observable<PIPSupportProgramLevelsVM[]> {
    return this._http.get('api/ProductImprovement/getPIPSupportLevel').share().map(
      (response: Response) => <PIPSupportProgramLevelsVM[]>response.json()).catch(this.handleError);
  }

  public addNewPIPDetails(existingTemplate: PIPDetailsVM): Observable<number> {
    return this._http.post("api/ProductImprovement/addNewPIPDetails", existingTemplate).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }


  public addsupportDoc(existingTemplate: PIPSupportDocVM[], PIPId: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PIPId', PIPId.toString());
    return this._http.post("api/ProductImprovement/addsupportDoc", existingTemplate, { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }


  public getSearcheProgImpInfromation(PIPId: number): Observable<PIPDetailsVM> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PIPId', PIPId.toString());
    return this._http.get('Api/ProductImprovement/getSearcheProgImpInfromation', { search: params }).share().map(
      (response: Response) => <PIPDetailsVM>response.json()).catch(this.handleError);
  }

  public getSupportDocforProductProg(PIPId: number): Observable<PIPSupportDocVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PIPId', PIPId.toString());
    return this._http.get('Api/ProductImprovement/getSupportDocforProductProg', { search: params }).share().map(
      (response: Response) => <PIPSupportDocVM[]>response.json()).catch(this.handleError);
  }

  public updateProdImprovement(existingTemplate: PIPDetailsVM,): Observable<boolean> {
    return this._http.post("api/ProductImprovement/updateProdImprovement", existingTemplate).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public updateSupportDocForPIP(existingTemplate: PIPSupportDocVM[], PIPId: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PIPId', PIPId.toString());
    return this._http.post("api/ProductImprovement/updateSupportDocForPIP", existingTemplate, { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }


  public searchPIPDetails(searchFields: PIPDetailsVM): Observable<PIPDetailsVM[]> {
    return this._http.post("api/ProductImprovement/searchPIPDetails", searchFields).share().map(
      (response: Response) => <PIPDetailsVM[]>response.json()).catch(this.handleError);
  }


  public getAssetAffectedbyPIP(): Observable<PIPImplementsVM[]> {

    return this._http.get('Api/ProductImprovement/getAssetAffectedbyPIP').share().map(
      (response: Response) => <PIPImplementsVM[]>response.json()).catch(this.handleError);
  }


  public GetAllForImplement(ImplementId: number): Observable<PIPImplmentsLevelVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', ImplementId.toString());
    return this._http.get("api/ProductImprovement/GetAllForImplement", { search: params }).share().map(
      (response: Response) => <PIPImplmentsLevelVM[]>response.json()).catch(this.handleError);
  }


  public GetPIPDetailsForAsset(ImplementId: number, PIPId: number): Observable<PIPImplemetLevelforAsset> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', ImplementId.toString());
    params.set('PIPId', PIPId.toString());
    return this._http.get("api/ProductImprovement/GetPIPDetailsForAsset", { search: params }).share().map(
      (response: Response) => <PIPImplemetLevelforAsset>response.json()).catch(this.handleError);
  }

  public UpdatePIPImplementAttachment(searchFields: PIPImplementAttachmentsVM): Observable<boolean> {
    return this._http.post("api/ProductImprovement/UpdatePIPImplementAttachment", searchFields).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public AddDeletePIPImplementImages(searchFields: PIPImplementImagesVM): Observable<boolean> {
    return this._http.post("api/ProductImprovement/AddDeletePIPImplementImages", searchFields).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public GetPIPImplementImages(PIPImpId: number): Observable<PIPImplementImagesVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PIPImpId', PIPImpId.toString());
    return this._http.get("api/ProductImprovement/GetPIPImplementImages", { search: params }).share().map(
      (response: Response) => <PIPImplementImagesVM[]>response.json()).catch(this.handleError);
  }

  public addPIPImplementAuditTrail(existingTemplate: PIPImplementAuditTrailVM, PIPId: number, ImplementId: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PIPId', PIPId.toString());
    params.set('ImplementId', ImplementId.toString());
    return this._http.post("api/ProductImprovement/addPIPImplementAuditTrail", existingTemplate, { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public getPIPAuditTrails(PIPImpId: number, ImplementId: number): Observable<PIPImplementAuditTrailVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PIPImpId', PIPImpId.toString());
    params.set('ImplementId', ImplementId.toString());
    return this._http.get('Api/ProductImprovement/getPIPAuditTrails', { search: params }).share().map(
      (response: Response) => <PIPImplementAuditTrailVM[]>response.json()).catch(this.handleError);
  }


  public getPIPforDashboard(selectedCustomer: number[]): Observable<PIPImplmentsLevelVM[]> {
    return this._http.post("api/ProductImprovement/getPIPforDashboard", selectedCustomer).share().map(
      (response: Response) => <PIPImplmentsLevelVM[]>response.json()).catch(this.handleError);
  }
  public getPIPforDashboardNotifications(ImplementID: number[]): Observable<PIPImplmentsLevelVM[]> {
    return this._http.post("api/ProductImprovement/getPIPforDashboardNotifications", ImplementID).share().map(
      (response: Response) => <PIPImplmentsLevelVM[]>response.json()).catch(this.handleError);
  }

  public sendPIPNotificatinEmailtoUsers(PIPId: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('PIPId', PIPId.toString());
    return this._http.get("api/ProductImprovement/sendPIPNotificatinEmailtoUsers", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public getCurrentUserAlertsforDashboard(): Observable<userAlertsVM[]> {
    return this._http.get("api/ProductImprovement/getCurrentUserAlertsforDashboard").share().map(
      (response: Response) => <userAlertsVM[]>response.json()).catch(this.handleError);
  }

  public getHistoryUserAlertsforDashboard(): Observable<userAlertsVM[]> {
    return this._http.get("api/ProductImprovement/getHistoryUserAlertsforDashboard").share().map(
      (response: Response) => <userAlertsVM[]>response.json()).catch(this.handleError);
  }


  public changeAlertStartus(ID: number, status: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ID', ID.toString());
    params.set('status', status.toString());
    return this._http.get("api/ProductImprovement/changeAlertStartus", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public clearHistory(): Observable<boolean> {
    return this._http.get("api/ProductImprovement/clearHistory").share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }


  public getObservationListforCustomer(CusID: number, FamId:number): Observable<GETObservationListVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('CusID', CusID.toString());
    params.set('FamId', FamId.toString());
    return this._http.get('Api/ObservationPoint/getObservationListforCustomer', { search: params }).share().map(
      (response: Response) => <GETObservationListVM[]>response.json()).catch(this.handleError);
  }
  public AddNewObservationPoint(searchFields: GETObservationListVM): Observable<boolean> {
    return this._http.post("api/ObservationPoint/AddNewObservationPoint", searchFields).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public getObservationforCustomer(obListID: number): Observable<GETObservationsCusVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('obListID', obListID.toString());
    return this._http.get('Api/ObservationPoint/getObservationforCustomer', { search: params }).share().map(
      (response: Response) => <GETObservationsCusVM[]>response.json()).catch(this.handleError);
  }

  public AddNewObservationPointforList(observationListID: number, selectedListName: string, selectedObservationNameforListarr: GETObservationsCusVM[], familyId: number | null): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();

    params.set('observationListID', observationListID.toString());
    params.set('selectedListName', selectedListName);
    params.set('FamId', String(familyId ?? 0));

    return this._http.post("api/ObservationPoint/AddNewObservationPointforList", selectedObservationNameforListarr, { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public deleteObservation(observatioId: number, flag: boolean): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('observatioId', observatioId.toString());
    params.set('Flag', flag ? "1" : "0");
    return this._http.get("api/ObservationPoint/deleteObservation", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }
  public deleteObservationList(observatioListId: number, flag: boolean): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('observatioListId', observatioListId.toString());
    params.set('flag', flag ? "1" : "0");
    return this._http.get("api/ObservationPoint/deleteObservationList", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public updateObservation(ObservationID: number, name: string): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ObservationID', ObservationID.toString());
    params.set('name', name);
    return this._http.get("api/ObservationPoint/updateObservation", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public EditProductImprovementAssetImages(info: PIPImplementImagesVM): Observable<any> {
    return this._http.post('api/ProductImprovement/EditProductImprovementAssetImages', info).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public setCrackSeverityListFlag(observatioListId: number, flag: boolean, listType: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('observatioListId', observatioListId.toString());
    params.set('flag', flag ? "1" : "0");
    params.set('listType', listType.toString());
    return this._http.get("api/ObservationPoint/SetCrackSeverityListFlag", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }


}
